export default __webpack_public_path__ + "static/media/TelegramMini.c0dc7158.svg";